import { useInitialState } from '@/hooks';
const access = (permission: string) => {
  const { access } = useInitialState.getState();
  return !!access[permission];
};
export default access;
